<template>
  <div>
    <h4 style="display: inline-block;">
      {{ $t("preparing") }}
    </h4>
    <p style="display:inline-block" class="ml-4">
      {{ images.length * 3 + " steps" }}
    </p>
    <vueper-slides
      :touchable="true"
      :arrows="false"
      :bullets="true"
      :visible-slides="1"
      fixedHeight="360px"
      bullets-outside
      v-if="images.length > 0"
    >
      <vueper-slide v-for="(image, i) in images" :key="i">
        <template #content>
          <img :src="image" />
        </template>
      </vueper-slide>
    </vueper-slides>
    <div>
      <p>
        {{ $t("description." + singleRecipe.key) }}
      </p>
    </div>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
export default {
  components: { VueperSlides, VueperSlide },
  data() {
    return {
      images: [],
      activeSlide: 0,
    };
  },
  computed: {
    singleRecipe: function() {
      return this.$store.getters["recipes/getRecipe"];
    },
    languages: function() {
      return this.$store.getters["labels/languages"];
    },
  },
  async mounted() {
    this.getImages();
    await this.importDescriptionsTranslations();
  },
  methods: {
    getImages() {
      const regex = new RegExp(/_[0-9]_[a-zA-Z0-9]*.png/);
      this.singleRecipe.media.data.forEach((element) => {
        if (element.attributes.url.match(regex)) {
          this.images.push(element.attributes.url);
        }
      });
      const r = /_(\d+)_[a-zA-Z0-9]*.png/;
      this.images = this.images.sort((a, b) => {
        let val1 = r.exec(a),
          val2 = r.exec(b);
        return parseInt(val1[1]) - parseInt(val2[1]);
      });
    },
    async importDescriptionsTranslations() {
      let translations = new Array(this.languages.length);
      this.languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
      });
      var path = "description." + this.singleRecipe.key;
      this.singleRecipe.labels.data.forEach((label) => {
        let index = translations.findIndex(
          (x) => x.locale === label.attributes.locale
        );
        var value = label.attributes.description.toString();
        var obj = translations[index].labels;
        var parts = path.split("."),
          part;
        var last = parts.pop();
        // eslint-disable-next-line no-cond-assign
        while ((part = parts.shift())) {
          if (typeof obj[part] != "object") obj[part] = {};
          obj = obj[part]; // update "pointer"
        }
        obj[last] = value;
      });
      translations.forEach((elem) => {
        let old = this.$i18n.getLocaleMessage(elem.locale);
        this.$i18n.setLocaleMessage(elem.locale, {
          ...old,
          ...elem.labels,
        });
      });
    },
  },
};
</script>

<style></style>
